module.exports = __webpack_public_path__ + "static/media/alis04.1f10124c.jpg";